import React, { useState} from 'react';
import isMobile from 'common/helpers/isMobile';
import classNames from 'classnames';

function PracticalInformation(props) {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className='practical-info'>
      <button
        className={classNames('practical-info__toggle-btn',
          {
            'is-active': isActive,
            'practical-info__toggle-btn--mobile': isMobile,
          }
        )}
        onClick={() => {
          setIsActive(!isActive);
        }}>
        {props.title}
      </button>
      <div
        className={classNames('practical-info__toggle-body',
          {
            'is-active': isActive,
          })}>
        <p dangerouslySetInnerHTML={{ __html: props.text }} className='practical-info__text'></p>
        <p className='practical-info__languages'>
          {props.languages}
        </p>
        <p className='practical-info__location'>
          {props.location}
        </p>
      </div>
    </div>

  );
}

export default  PracticalInformation;
